import { IconComponent, SmallIcon } from "@nova/component-icons"
import { useTranslation } from "@nova/use-translation"

type WorkspacePanelEmptySectionMessageProps = {
    title: string
    Icon: IconComponent
}

export const WorkspacePanelEmptySectionMessage = ({
    title,
    Icon,
}: WorkspacePanelEmptySectionMessageProps) => {
    const { t } = useTranslation()

    return (
        <div className="px-4 py-1.5 flex items-center gap-1 text-gray-500 select-none h-9 relative">
            <SmallIcon Icon={Icon} />
            <h5>{t(title)}</h5>
        </div>
    )
}
